import theme from '@styles/theme';
export default {
  section: {
    background: 'lightGreyBg2',
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    minHeight: ['calc(100vh - 96px)', 'calc(100vh - 96px)', '73.3072917vw', '73.3072917vw', '46.875vw'],
    '& *': {
      WebkitTouchCallout: 'none',
      WebkitUserSelect: 'none',
      KhtmlUserSelect: 'none',
      MozUserSelect: 'none',
      msUserSelect: 'none',
      userSelect: 'none'
    }
  }
};